import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const updateEvidence = async (evidenceData) => {
  try {
    const response = await axios.put(`${API_URL}/evidence`, evidenceData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error updating evidence:", error);
    throw error;
  }
};

export default updateEvidence;
